import React from "react";
import { Field, ErrorMessage } from "formik";
import { Form as BootstrapForm } from "react-bootstrap";

const SelectField = ({ label, name, options = [], onChange }) => {
  return (
    <BootstrapForm.Group className="mb-3">
      <BootstrapForm.Label>{label}</BootstrapForm.Label>
      <Field
        as="select"
        name={name}
        className="form-control"
        onChange={(e) => {
          if (onChange) onChange(e.target.value);
        }}
      >
        <option value="">Select {label}</option>
        {options.map((option) => (
          <option key={option.slug || option.value} value={option.slug || option.value}>
            {option.name || option.label}
          </option>
        ))}
      </Field>
      <ErrorMessage name={name} component="div" className="text-danger small" />
    </BootstrapForm.Group>
  );
};

export default SelectField;
